export function replaceSoftHyphenWithUnicode(val: string) {
  return val.replaceAll(/&shy;/g, '\u00AD');
}
